import React from 'react';
import { motion } from 'framer-motion';
import { HeroOrnament } from './HeroOrnament';
import type { Lang, LocaleContent } from '../types/profile';
interface HeroProps {
  lang: Lang;
  content: LocaleContent;
}
const ease = [0.22, 1, 0.36, 1] as const;
export function Hero({
  lang,
  content
}: HeroProps) {
  const isThai = lang === 'th';
  return <section id="top" className="relative overflow-hidden" data-id="element-8" data-mp="4jm69oq8r3r3">
      <HeroOrnament data-id="element-9" data-mp="128frrovbsnyc" />

      <div className="relative mx-auto max-w-6xl px-5 pb-16 pt-12 sm:px-8 sm:pt-20 lg:pb-24 lg:pt-24 print:pb-6 print:pt-0" data-id="element-10" data-mp="128pjbgw0r365">
        <motion.div data-reveal initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease
      }} className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[14px] text-ink-soft" data-id="element-11" data-mp="x8jjhdfliacz">
          <span className="inline-flex items-center gap-3" data-id="element-12" data-mp="3d2tod9lewkej">
            <span aria-hidden="true" className="h-px w-8 bg-sage-deep" data-id="element-13" data-mp="3825xqp13i5ku" />
            <span className="font-medium text-charcoal" data-id="element-14" data-mp="3j8ivmv0mo8sl">{content.eyebrow}</span>
          </span>
          <span aria-hidden="true" className="h-1 w-1 rounded-full bg-sage" data-id="element-15" data-mp="3o7lq5lizewmb" />
          <span data-id="element-16" data-mp="3o5j2v997rhla">{content.descriptor}</span>
        </motion.div>

        <h1 className="mt-8 whitespace-nowrap font-display font-light tracking-[-0.035em] text-charcoal sm:mt-10" aria-label="0xLift" data-id="element-17" data-mp="399jmzcfv4d5l">
          <motion.span data-reveal initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease,
          delay: 0.05
        }} className="inline-block text-[5rem] leading-[1.05] sm:text-[7rem] lg:text-[10rem] print:text-[55pt]" data-id="element-18" data-mp="3ebiqqnfilc32">
            0x
          </motion.span><motion.span data-reveal initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease,
          delay: 0.15
        }} className="inline-block font-display text-[5rem] italic leading-[1.05] text-sage-deep sm:text-[7rem] lg:text-[10rem] print:text-[55pt]" data-id="element-19" data-mp="2vi56bc9fgo1p">
            Lift
          </motion.span>
        </h1>

        <motion.div id="about" data-reveal initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease,
        delay: 0.3
      }} className="mt-14 grid scroll-mt-32 gap-8 border-t border-line pt-10 sm:mt-20 lg:grid-cols-12 lg:gap-10 lg:pt-12 print:mt-8 print:pt-6" data-id="element-20" data-mp="na9xyj16r4ia">
          <div className="lg:col-span-4" data-id="element-21" data-mp="1622hznya1fdv">
            <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-sage-deep" data-id="element-22" data-mp="16344qponnqbf">
              01 — {content.aboutLabel}
            </p>
            <h2 className={`mt-4 text-charcoal ${isThai ? 'font-display text-[1.9rem] leading-[1.45] sm:text-[2.25rem]' : 'font-display text-[2rem] italic leading-[1.1] sm:text-[2.5rem]'}`} data-id="element-23" data-mp="x14mju1wmg6w">
              {content.subtitle}
            </h2>
          </div>

          <div className="space-y-6 lg:col-span-7 lg:col-start-6" data-id="element-24" data-mp="1xam4cnf59kxc">
            <p className={`text-charcoal ${isThai ? 'text-[1.15rem] leading-[1.95] sm:text-[1.25rem]' : 'text-[1.2rem] leading-[1.6] sm:text-[1.35rem]'}`} data-id="element-25" data-mp="21aejxk2ygrc7">
              {content.intro[0]}
            </p>
            <p className={`border-l border-sage/60 pl-5 text-[17px] text-ink-soft ${isThai ? 'leading-[1.95]' : 'leading-[1.75]'}`} data-id="element-26" data-mp="2g0c1hh6dqisf">
              {content.intro[1]}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}